import { Injectable } from "@angular/core";
import { ApiResourceService } from "../../libraries/service/apiResource/apiResource.service";
import { Observable } from "rxjs";
import { IWatabiLightBooking } from "../../libraries/interfaces/watabilight/IWatabiLightBooking.interface";
import { BookingService } from "./booking.service";
import { DummyCheckboxService } from "libraries/dummyCheckbox/dummyCheckbox.service";

declare const userId: string;
declare const userCompanyId: string;

const URL_WATABI: string = "watabi";
const URL_WATABI_LIGHT: string = "watabilight";
const URL_ITEMS: string = "items";
const URL_GET_CONFIG: string = "getConfig";
const URL_UPLOAD_LOGO: string = "uploadLogo";
const URL_RESTITUTION: string = "restitution";
const URL_BOOKINGS: string = "bookings";
const URL_VERSIONS: string = "versions";
const URL_EXTERNAL_SERVICES: string = "external-services";
const URL_CREATE: string = "create";
const URL_CHECK: string = "check";
const URL_MAILS: string = "mails";
const URL_SEND: string = "send";

@Injectable()
export class WatabilightService {
    constructor(
        private readonly apiResourceService: ApiResourceService,
        private readonly bookingService: BookingService,
        private readonly dummyCheckboxService: DummyCheckboxService,
    ) {
    }

    public getBooking(idBooking: string, idVersion: string): Observable<IWatabiLightBooking> {
        return this.apiResourceService.getOne<IWatabiLightBooking>(
            this.apiResourceService.getApiUrl(URL_WATABI, URL_ITEMS, idBooking, idVersion),
            {},
            {}
        );
    }

    public getConfig(idVersion: string): Observable<IWatabiLightBooking> {
        return this.apiResourceService.getOne<IWatabiLightBooking>(
            this.apiResourceService.getApiUrl(URL_WATABI, URL_GET_CONFIG, idVersion),
            {},
            {}
        );
    }

    public uploadFile(data: any, idAgency: number, ext: string): Observable<any> {
        return this.apiResourceService.postOne<any, any>(
            this.apiResourceService.getApiUrl(URL_WATABI, URL_WATABI_LIGHT, URL_UPLOAD_LOGO, idAgency, ext),
            data,
            {},
            {}
        );
    }

    public switchXToken(): void {
        const tmpToken: string = sessionStorage.getItem('_tmp_xtoken');
        const token: string = sessionStorage.getItem('xtoken');

        sessionStorage.setItem('xtoken', tmpToken);
        sessionStorage.setItem('_tmp_xtoken', token);
    }

    public preview(config: any): Observable<any> {
        this.switchXToken();

        return this.apiResourceService.postOne(
            this.apiResourceService.getApiServerUrl(URL_WATABI, URL_RESTITUTION, this.bookingService.getBookingIdVersion() + '.html'),
            config,
            {}
        );

    }

    public check(): Observable<any> {
        return this.apiResourceService.postOne(
            this.apiResourceService.getApiUrl(URL_WATABI, URL_BOOKINGS, this.bookingService.getBookingId(), URL_EXTERNAL_SERVICES, URL_CHECK),
            {},
            {}
        );
    }

    public apiPublicVersioning(): Observable<any> {
        this.switchXToken();
        return this.apiResourceService.postOne(
            this.apiResourceService.getApiServerUrl(URL_WATABI, URL_BOOKINGS, this.bookingService.getBookingIdVersion(), URL_VERSIONS, URL_CREATE),
            {},
            {
                style: 'Native',
                forceVersion: 1
            }
        );
    }

    public generate(config: any): Observable<any> {
        return this.apiResourceService.postOne(
            this.apiResourceService.getApiServerUrl(URL_WATABI, URL_CREATE, URL_RESTITUTION, this.bookingService.getBookingIdVersion()),
            config,
            {}
        );
    }

    public postData(data: any): Observable<any> {
        return this.apiResourceService.postOne(
            this.apiResourceService.getApiUrl(URL_WATABI, URL_ITEMS, this.bookingService.getBookingId(), this.bookingService.getBookingIdVersion()),
            data,
            {}
        );
    }

    public sendFinalMail(data: any): Observable<any> {
        this.dummyCheckboxService.isDummy = false;
        this.switchXToken();
        const searchParams = new URLSearchParams();

        Object.keys(data).forEach(key => searchParams.append(key, data[key]));
        const body = searchParams.toString();
        return this.apiResourceService.post(
            this.apiResourceService.getApiServerUrl(URL_MAILS, URL_SEND),
            body,
            {},
            {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        );
    }
}
